/**
 * 权限相关的校验
 * 需要统一处理所有的权限目前为
 * 后期处理成指令
 */
import * as Util from 'js/util/util'

export const RIGHT = {
  computed: {
    btnEditOLRight() {
      return this.getRight('editOL')
    },
    btnWebLocalEditRight() {
      return this.getRight('webLocalEdit')
    },
    btnClientLocalEditRight() {
      return this.getRight('clientLocalEdit')
    },
    btnDownloadRight() {
      return this.getRight('download')
    },
    btnCommonLinkRight() {
      return this.getRight('commonLink')
    },
    btnSecurteLinkRight() {
      return this.getRight('securteLink')
    },
  },
  methods: {
    /**
         * 获取按钮的权限
         * @param {*} key
         * @param {*} data
         */
    getRight(key) {
      // editOL
      // webLocalEdit
      // clientLocalEdit
      // download
      // commonLink
      // securteLink
      if (this[`${key}Right`] && this[`${key}Right`] instanceof Function) {
        return this[`${key}Right`](this.fileData)
      }
      return false
    },
    /**
         * 判断doc编辑的权限
         */
    editOLRight(d) {
      const {
        access_mode: accessMode, mime_type: mimeType, lock_uid: lockUid,
        support_edit: supportEdit, is_open_wps_edit: isOpenWpsEdit,
      } = d
      let flag = false
      const islocked = Boolean(lockUid)
      const unlockAdmin = Util.unlockAdmin(d)
      if (isOpenWpsEdit === 'true') {
        if (Util.canEditOL(accessMode) && supportEdit === 'true') {
          flag = true
        }
        if (islocked && !unlockAdmin) { // 被别人锁定 不展示编辑
          flag = false
        }
        return flag
      }
      if (Util.canEditOL(accessMode) && Util.canEditType(mimeType)) {
        flag = true
      }
      if (islocked && !unlockAdmin) { // 被别人锁定 不展示编辑
        flag = false
      }
      return flag
    },
    /**
         * web本地编辑
         */
    webLocalEditRight(d) {
      if (!d) {
        return false
      }
      let flag = false
      const {
        access_mode: accessMode, mime_type: mineType, lock_uid: lockUid,
      } = d
      const islocked = Boolean(lockUid)
      const unlockAdmin = Util.unlockAdmin(d)
      if (Util.privateCloudCanLocalEdit(accessMode)
        && Util.privateCloudCanLocalEditType(mineType)) {
        flag = true
      }
      if (islocked && !unlockAdmin) { // 被别人锁定 不展示编辑
        flag = false
      }
      if(Util.isLinux() && mineType.indexOf('.txt') > -1){
        flag = false
      }
      return flag
    },
    /**
         * 客户端本地打开
         */
    clientLocalEditRight(d) {
      if (!d) {
        return false
      }
      return d && Util.canLocalEdit(d)
    },
    /**
         * 下载
         * @param {} d
         */
    downloadRight(d) {
      return Util.ifHasAuth(d.access_mode, 'download')
    },
    /**
         * 新建链接
         */
    commonLinkRight(d) {
      return Util.canCreateNewLink(d)
    },
    /**
         * 个人文件不能创建安全外链 所以需要单独处理，目前view是拿ent来判断的，外链需要参考web，预览二期优化的时候统一处理
         * @param {*} d
         */
    securteLinkRight(d) {
      // view项目安全外链
      // let len = store.getters.selectedDataLength;
      // if (len !== 1) return false;
      // let {security_delivery} = this.accountConfig,
      //     {is_dir} = this.selectedData;
      // return (this.pathType === 'ent' || this.itemPathType === 'ent') && security_delivery == '2' && !is_dir;
      const { security_delivery: securityDelivery } = window.store.getters.accountConfig
      return this.commonLinkRight(d) && securityDelivery === '2' && this.$route.params.from === 'ent'
    },
  },
}
